module.exports = __webpack_public_path__ + "static/media/classique_masked_web.9e4c9bf0.png";